import AuthService from "../services/auth.service";

const user = JSON.parse(localStorage.getItem("user"));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

initialState["userVerifyData"] = null;

export const auth = {
  namespaced: true,
  state: initialState,


  actions: {
    login({ commit }, userData) {
      return AuthService.login(userData).then(
        (user) => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },

    register({ commit }, user) {
      return AuthService.register(user).then(
        (user) => {
          commit("registerSuccess");
          return Promise.resolve(user);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },

    forgotOtpSend({ commit }, user) {
      return AuthService.forgotOtpSend(user).then(
        (user) => {
          commit("registerSuccess");
          return Promise.resolve(user);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },

    ResetPassword({ commit }, user) {
      return AuthService.ResetPassword(user).then(
        (user) => {
          commit("registerSuccess");
          return Promise.resolve(user);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },

    logout({ commit }) {
      commit("logout");
    },

    storeUserVerifyData({ commit }, user) {
      commit("setUserVerifyData", user);
    },
  },

  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },

    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
      localStorage.removeItem("user");
    },

     registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },

    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      localStorage.removeItem("user");
    },

    setUserVerifyData(state, user) {
      state.userVerifyData = user;
      localStorage.setItem("userVerifyData", JSON.stringify(user));
    },
  },
};
